import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import PolicyItem from "./item";
import PolicyTitle from "./title";
import PolicyContent from "./content";
import { PolicyContext } from "./context";

const Policy = ({ children, classOption }) => {
    const [ids, setIds] = useState([]);
    const [activeId, setActiveId] = useState("");
    const [isInit, setIsInit] = useState(true);

    const toggleActive = (id) => {
        if (id === activeId) {
            setActiveId("");
        } else {
            setActiveId(id);
        }
    };

    const setIdsOnInit = (id) => {
        setIds((ids) => [...ids, id]);
    };

    const setActiveIdOnInit = () => {
        if (!activeId) setActiveId(ids[0]);
    };

    useEffect(() => {
        setActiveIdOnInit();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ids.length]);

    return (
        <PolicyContext.Provider
            value={{
                ids,
                setIds,
                activeId,
                setActiveId,
                toggleActive,
                setIdsOnInit,
                isInit,
                setIsInit,
            }}
        >
            <div className={`policy ${classOption}`}>{children}</div>
        </PolicyContext.Provider>
    );
};

Policy.propTypes = {
    children: PropTypes.node.isRequired,
    classOption: PropTypes.string,
};
Policy.defaultProps = {
    classOption: "policy",
};

export { PolicyItem, PolicyTitle, PolicyContent };

export default Policy;
